/** Settings -> Planning -> Calendar and the case deadlines (Phase 2 P2-2, P19-P20). */
export default {
  calendar: {
    title: 'Working-day calendar',
    description:
      'The weekends and public holidays that deadlines in working days are counted with. Import a new year when it is announced, and add your own closures here.',
    originTenant: 'Saved for this organisation',
    originPack: 'The default calendar (not saved yet)',
    originNone: 'No calendar: no deadline can be counted, in working days or calendar days, until one is imported.',
    revision: 'Revision {{revision}}',
    coverage: 'Covers {{from}} to {{to}}',
    timezone: 'Time zone: {{zone}}',
    weekends: 'Weekends',
    weekendOpen: '{{days}} from {{from}}',
    weekendClosed: '{{days}} from {{from}} to {{to}}',
    holidays: 'Holidays',
    provisional: 'Provisional',
    source: 'Source',
    noSource: 'No public source',
    remove: 'Remove',
    removeTitle: 'Remove {{name}} ({{date}})?',
    removeBody:
      'Deadlines counted after you save will treat {{date}} as a working day. This saves a new revision of the calendar.',
    removeReplacements: 'These replacement days are removed with it:',
    removeRestore:
      'The add form cannot recreate a public holiday or a replacement day. To restore one later, import a calendar file that has it; export the calendar first to keep a copy.',
    removeConfirm: 'Remove holiday',
    removeCancel: 'Cancel',
    add: 'Add a holiday or closure',
    date: 'Date',
    nameMs: 'Name (Malay)',
    nameEn: 'Name (English)',
    kind: 'Kind',
    kindAdhoc: 'Declared holiday (with a public source)',
    kindTenant: 'Our own closure',
    sourceUrl: 'Source URL',
    note: 'Note',
    addSubmit: 'Add',
    nameRequired: 'Enter a name.',
    dateRequired: 'Choose a date inside the calendar’s coverage.',
    sourceRequired: 'A declared holiday needs the link to its announcement.',
    import: 'Import a JSON file',
    export: 'Export as JSON',
    schema: 'Download the file format (JSON Schema)',
    importFailed: 'That file could not be read as JSON.',
    saved: 'Calendar saved (revision {{revision}}).',
    saving: 'Saving the calendar…',
    notNewer:
      'A newer version of this calendar is already saved (revision {{revision}}). Reload the page and try again.',
    uncovered:
      'Running deadlines with no due date: {{count}}. They count past {{to}}; import a calendar that covers them.',
    uncoveredNoCalendar:
      'Running deadlines with no due date: {{count}}. Without a calendar none of them can be counted; import one.',
    loadFailed: 'The calendar could not be loaded.',
  },
  clocks: {
    title: 'Deadlines',
    running: 'Running',
    paused: 'Paused',
    stopped: 'Stopped',
    expired: 'Expired',
    due: 'Due {{date}}',
    dueSoon: 'Due soon',
    noDue: 'No due date',
    uncovered: 'No calendar covers this deadline yet.',
    workingDays: 'working days',
    calendarDays: 'calendar days',
    extensions: 'Extensions: {{count}}',
    pausedFor: 'Time paused: {{days}} days',
  },
} as const
